var path = '/common/component/video-facebook/tpl/video-facebook.html';
var html = "<div class=\"media fb-video-container\"> <div id=fb-responsive> <div class=fb-video data-href={{$ctrl.videoUrl}} data-width=5000 data-autoplay={{$ctrl.kioskMode}} data-allowfullscreen=false></div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/component/video-facebook/tpl/video-facebook.html
// module id = 126
// module chunks = 0 1 2 3 4